import { useQuery, useMutation } from "@apollo/client";
import { GET_USER_CARDS, DECRYPT_CARD_NUMBER, ACTIVATE_VIRTUAL_CARD, SUSPEND_VIRTUAL_CARD, UPDATE_CARD_STATUS } from "../graphql/cards";
import { useAuth } from "../lib/auth";

export const useCards = () => {
  const { user } = useAuth();
  const { data, loading, error, refetch } = useQuery(GET_USER_CARDS, {
    variables: { userId: user?.id },
    skip: !user?.id,
  });

  return {
    physicalCards: data?.physical_cards || [],
    virtualCards: data?.virtual_cards || [],
    loading,
    error,
    refetch,
  };
};

export const useDecryptCard = () => {
  const [decrypt, { loading }] = useMutation(DECRYPT_CARD_NUMBER);

  const decryptCard = async (cardId: string, cardType: "PHYSICAL" | "VIRTUAL") => {
    const result = await decrypt({
      variables: {
        input: { cardId, cardType },
      },
    });
    return result.data?.decryptCardNumber;
  };

  return { decryptCard, loading };
};

export const useCardActions = () => {
  const [activateMutation, { loading: activateLoading }] = useMutation(ACTIVATE_VIRTUAL_CARD);
  const [suspendMutation, { loading: suspendLoading }] = useMutation(SUSPEND_VIRTUAL_CARD);
  const [updateStatusMutation, { loading: statusLoading }] = useMutation(UPDATE_CARD_STATUS);

  const activateCard = async (cardId: string) => {
    const result = await activateMutation({
      variables: { input: { cardId } },
    });
    return result.data?.activateVirtualCard;
  };

  const suspendCard = async (cardId: string) => {
    const result = await suspendMutation({
      variables: { input: { cardId } },
    });
    return result.data?.suspendVirtualCard;
  };

  const updateStatus = async (cardId: string, status: string, reason?: string) => {
    const result = await updateStatusMutation({
      variables: { input: { cardId, status, reason } },
    });
    return result.data?.updateCardStatus;
  };

  return {
    activateCard,
    suspendCard,
    updateStatus,
    loading: activateLoading || suspendLoading || statusLoading,
  };
};
